import { useQuery } from '@tanstack/react-query';
import { IEvent } from '../../ScoutCalendar/types';
import Api from '../../ScoutCalendar/API';
import newDateFromString from '../../shared/dateHelper';

interface IProps {
  weekStart: Date;
  onError: (message: string) => void;
}

export const useEvents = ({ weekStart, onError }: IProps) => {
  const { data, isLoading } = useQuery({
    queryKey: ['events', weekStart],
    queryFn: async () => {
      const {
        res: { events }
      } = await Api.getEvents(weekStart);
      return events.map((e: IEvent) => ({
        ...e,
        start: newDateFromString(e.begins_at),
        end: newDateFromString(e.ends_at)
      }));
    },
    onError: (error: string) => {
      onError(error);
    }
  });

  return {
    data,
    isLoading
  };
};

export default useEvents;
